<template>
    <LayoutWrapper :id="id">
        <LayoutPaddingSpace>
            <LayoutColumn>
                <SectionTitle>
                    {{ $t('Search.labels.searchParameters') }}
                </SectionTitle>
                <SectionBlock>
                    <SubjectLengthField />
                    <SubjectCoverageField />
                </SectionBlock>
            </LayoutColumn>
        </LayoutPaddingSpace>
        <ResetSection />
    </LayoutWrapper>
</template>

<script>
import BioSearchSettingProvider from '../BioSearchSettingProvider.vue';

export default {
    extends: BioSearchSettingProvider,
};
</script>
